import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    OnChanges,
    OnDestroy,
    OnInit, SimpleChanges,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {CommonModule, DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle} from "@angular/material/card";
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell, MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef, MatNoDataRow,
    MatRow, MatRowDef, MatTable, MatTableDataSource
} from "@angular/material/table";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatMenu, MatMenuPanel, MatMenuTrigger} from "@angular/material/menu";
import {MatOption} from "@angular/material/autocomplete";
import {MatPaginator} from "@angular/material/paginator";
import {MatSelect} from "@angular/material/select";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {MatTooltip} from "@angular/material/tooltip";
import {CookieService} from "ngx-cookie-service";
import {DialogService} from "../../_modal/dialog.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {CustomizerSettingsService} from "../../../customizer-settings/customizer-settings.service";
import {OverlayContainer} from "@angular/cdk/overlay";
import {HandleErrorsService} from "../../../services/handle-erros/handle.errors.service";
import {environment} from "../../../../environments/environment";
import {OT_DTO} from "../../_models/OT_DTO";
import {RapportDTO} from "../../_models/rapport-dto";
import {RapportService} from "../../../services/rapport-service/rapport.service";
import {Endpoints} from "../../endpoints";
import { finalize, forkJoin, tap } from 'rxjs';
import { SampleService } from '../../../services/sample-service/sample.service';
import saveAs from 'file-saver';
import { SampleDTO } from '../../_models/sampleDTO';
import { DevisService } from '../../../services/devis-service/devis.service';
import { DevisDTO, StatutsDevis } from '../../_models/DevisDTO';
import { Router } from '@angular/router';
import { ClientsService } from '../../../services/client-service/clients.service';
import { TypeAnalyseService } from '../../../services/type-analyse-service/type.analyse.service';
import { MatIconModule } from '@angular/material/icon';
import { SafePipe } from '../../../safe.pipe';

@Component({
    selector: 'app-devis',
    standalone: true,
    providers: [DialogService, SafePipe,HandleErrorsService, RapportService, Endpoints],
    imports: [        SafePipe,

        DatePipe,
        FormsModule,
        MatButton,MatIconModule,
        MatCard,
        MatCardContent,
        MatCardHeader,
        MatCardSubtitle,
        MatCardTitle,
        MatCell,
        MatCellDef,
        MatCheckbox,
        MatColumnDef,
        MatDatepicker,
        MatDatepickerInput,
        MatDatepickerToggle,
        MatError,
        MatFormField,
        MatHeaderCell,
        MatHeaderRow,
        MatHeaderRowDef,
        MatInput,
        MatLabel,
        MatMenu,
        MatOption,
        MatPaginator,
        MatRow,
        MatRowDef,
        MatSelect,
        MatSort,
        MatSortHeader,
        MatSuffix,
        MatTab,
        MatTabGroup,
        MatTable,
        MatTooltip,
        NgForOf,
        NgIf,
        ReactiveFormsModule,
        MatHeaderCellDef,
        MatMenuTrigger,
        NgClass,
        MatNoDataRow,
        CommonModule
    ],
    templateUrl: './devis.component.html',
    styleUrl: './devis.component.scss'
})
export class DevisComponent implements OnInit, OnChanges, AfterViewInit {
editModal: TemplateRef<DevisDTO>;
menu: MatMenuPanel<any>|null;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    form: FormGroup;
    searchValue: string = '';
    devis?: DevisDTO;
    rapportId: number; 
    loadingDevis: boolean = false;
    dataSource: MatTableDataSource<DevisDTO> = new MatTableDataSource<DevisDTO>();
    selectedRapport: Set<DevisDTO> = new Set<DevisDTO>(); 
    isAllRapportSelected: boolean = false;
    sampleIds: number[] = []; 
    statutsDevis = Object.values(StatutsDevis);
    statuts = StatutsDevis;

    displayedColumns: string[] = [
        'select',  
        'numeroDevis',
        'dateCreation',
        'dateExpiration',
        'dateLivraison',
        'delaiLivraison',
        'methodeExpedition',
        'conditionReglement',
        'totalHT',
        'totalTTC',
        //'clientNom',  
        'typeAnalyseNom',  
        'status',
        'validite',
        'action'
      ];  

    columns: string[] = [...this.displayedColumns];

    loadingTable: boolean = true;
    loadingOT: boolean = false;
    loadingPdfGen: boolean = false; 
    viewModal: TemplateRef<DevisDTO>;

    constructor(
        private cookieService: CookieService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private cdr: ChangeDetectorRef,
        private overlayContainer: OverlayContainer,
        private rapportService: RapportService,
        private devisService:DevisService,
        private sampleService:SampleService,
        private handleErrors: HandleErrorsService,
        private router: Router,
        private clientService: ClientsService,
        private typeAnalyseService: TypeAnalyseService
    ) {
        this.initializeForm();
    }
    clients: any[] = [];
    typeAnalyses: any[] = [];
    Form: FormGroup;
    detailForm!: FormGroup;
    statuses: string[] = [];  
    detailsList: any[] = [];


    ngOnInit() {
      this.form = this.fb.group({
        id: ['', Validators.required],  
        //numeroDevis: ['', Validators.required],
        clientReference: [''], 
        action: [''], 
        clientId: ['', Validators.required],
        dateCreation: ['', Validators.required],
        dateExpiration: ['', Validators.required],
        dateLivraison: ['', Validators.required],
        delaiLivraison: ['', Validators.required],
        methodeExpedition: ['', Validators.required],
        conditionReglement: ['', Validators.required],
        validite: ['', Validators.required],
        status: ['', Validators.required],
        tvaApplicable: [],  
        details: this.fb.array([])  
    }); 
    this.detailForm = this.fb.group({
      typeAnalyseId: [null, Validators.required],
      qte: [null, Validators.required],
      prixUnitaire: [null, Validators.required],
      total: [{ value: 0, disabled: true }] 
    });
          this.Form = this.fb.group({
            clientId: ['', Validators.required],
            clientReference: [''],
            dateExpiration: ['', Validators.required],
            dateLivraison: ['', Validators.required],
            delaiLivraison: ['', Validators.required],
            methodeExpedition: ['', Validators.required],
            conditionReglement: ['', Validators.required],
            validite: ['', Validators.required],
            status: [''],
            tvaApplicable: [true],  
            details: this.fb.array([])  
          });
          
        console.log('Chargement des données...');
        this.loadClients();
        this.loadTypeAnalyses();
        this.fetchDevisList(); 
        this.loadClientsAndTypeAnalyses()
    }
    onTypeAnalyseChangex() {
      const selectedId = this.detailForm.get('typeAnalyseId')?.value;
      console.log('Selected Type Analyse ID:', selectedId);  
      
      const selected = this.typeAnalyses.find(t => t.id === selectedId);
      console.log('Selected Type Analyse:', selected);  
      
      if (selected) {
        this.detailForm.get('prixUnitaire')?.setValue(selected.prix);
        console.log('Prix Unitaire mis à jour:', selected.prix);  
      }
    }

    pdfPreviewUrl: string | null = null;
    showPdfPreview(pdfBase64: string | undefined): void {
      console.log('PDF Base64:', pdfBase64);  // Vérifie la valeur ici
      if (pdfBase64) {
        this.pdfPreviewUrl = pdfBase64;
      } else {
        console.error("Le PDF n'est pas disponible.");
      }
    }    

  setDetails(details: any[]): void {
    const control = <FormArray>this.form.controls['details'];
    details.forEach(d => {
      control.push(this.fb.group({
        id: [d.id],
        typeAnalyseId: [d.typeAnalyseId, Validators.required],
        qte: [d.qte, Validators.required],
        prixUnitaire: [d.prixUnitaire, Validators.required],
        typeAnalyseNom: [d.typeAnalyseNom],
        total : [d.qte * d.prixUnitaire]

      }));
    });
  }

    
addDetailx() {
  if (this.detailForm.valid) {
    const qte = this.detailForm.value.qte;
    const prixUnitaire = this.detailForm.value.prixUnitaire;
    const total = qte * prixUnitaire;

    // Ajout à detailsList avec total
    this.detailsList.push({
      ...this.detailForm.value,
      total: total
    });

    // Création du FormGroup avec total
    const newDetail = this.fb.group({
      typeAnalyseId: [this.detailForm.value.typeAnalyseId, Validators.required],
      qte: [qte, Validators.required],
      prixUnitaire: [prixUnitaire, Validators.required],
      total: [{ value: total, disabled: true }]  // total calculé et désactivé
    });

    // Ajout au FormArray
    (this.Form.get('details') as FormArray).push(newDetail);

    // Reset du formulaire de détail, en remettant total à 0 ou null
    this.detailForm.setValue({
      typeAnalyseId: null,
      qte: null,
      prixUnitaire: null,
      total: 0
    });

    this.detailForm.markAsPristine();
    this.detailForm.markAsUntouched();
  }
}


resetDetailForm(): void {
    this.detailForm.reset({
        typeAnalyseId: null,
        qte: null,
        prixUnitaire: null
    });
    this.detailForm.markAsPristine();
    this.detailForm.markAsUntouched();
}

    
addDetailf() {
  if (this.detailForm.valid) {
    const qte = this.detailForm.value.qte;
    const prixUnitaire = this.detailForm.value.prixUnitaire;
    const total = qte * prixUnitaire;

    // Ajout à detailsList avec total
    this.detailsList.push({
      ...this.detailForm.value,
      total: total
    });

    // Création du FormGroup avec total
    const newDetail = this.fb.group({
      typeAnalyseId: [this.detailForm.value.typeAnalyseId, Validators.required],
      qte: [qte, Validators.required],
      prixUnitaire: [prixUnitaire, Validators.required],
      total: [{ value: total, disabled: true }]  // total calculé et désactivé
    });

    // Ajout au FormArray
    (this.form.get('details') as FormArray).push(newDetail);

    // Reset du formulaire de détail, en remettant total à 0 ou null
    this.detailForm.setValue({
      typeAnalyseId: null,
      qte: null,
      prixUnitaire: null,
      total: 0
    });

    this.detailForm.markAsPristine();
    this.detailForm.markAsUntouched();
  }
}


    removeDetailx(index: number) {
      this.detailsList.splice(index, 1);
      this.Form.get('details')?.setValue(this.detailsList);
      this.Form.get('details')?.markAsDirty();
      this.Form.get('details')?.updateValueAndValidity();
    }
    removeDetailF(index: number) {
      this.detailsList.splice(index, 1);
      const detailsFormArray = this.form.get('details') as FormArray;
      detailsFormArray.removeAt(index); 
      detailsFormArray.markAsDirty();
      detailsFormArray.updateValueAndValidity();
    }
   
    getTypeAnalyseName(id: number): string {
      const type = this.typeAnalyses.find(t => t.id === id);
      return type ? type.name : '';
    }
    getTypeAnalyseDelai(id: number): string {
      const type = this.typeAnalyses.find(t => t.id === id);
      return type ? type.dureeAna : '';
    }
    getTypeAnalyseMethode(id: number): string {
      const type = this.typeAnalyses.find(t => t.id === id);
      return type ? type.name : '';
    }
    getTypeAnalyseDesc(id: number): string {
      const type = this.typeAnalyses.find(t => t.id === id);
      return type ? type.description : '';
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes['dataSource']) {
            this.initializeForm();
        }
    }
      createDetail(): FormGroup {
        return this.fb.group({
          typeAnalyseId: ['', Validators.required], 
          qte: ['', Validators.required],  
          prixUnitaire: ['', Validators.required], 
          total: [{ value: 0, disabled: true }], // ✅ affichage facultatif

        });
      }
      
      get details(): FormArray {
        return this.Form.get('details') as FormArray;
      }
      
      loadClients(): void {
        console.log('Chargement des clients...');
      
        this.clientService.loadClients().subscribe(
          (response) => {
            console.log('Réponse brute des clients:', response); 
            console.log('Clients chargés avec succès:', response.data); 
            this.clients = response.data; 
          },
          (error) => {
            console.error('Erreur lors du chargement des clients:', error);
          }
        );
    }
    
      prixUnitaire: number = 0; 
      loadTypeAnalyses(): void {
        this.typeAnalyseService.getAllTypeAnalyses().subscribe(
            (response) => {
                if (Array.isArray(response)) {
                    console.log("Types d'analyses chargés avec succès:", response);
                    this.typeAnalyses = response;
                } else {
                    console.error("La réponse API ne contient pas un tableau de types d'analyses", response);
                }
            },
            (error) => {
                console.error("Erreur lors du chargement des types d'analyses:", error);
            }
        );
    }

    loadClientsAndTypeAnalyses() {
      console.log('Chargement des clients et des types d\'analyses...');
      
      forkJoin({
        clients: this.clientService.loadClients(),
        typeAnalyses: this.typeAnalyseService.getAllTypeAnalyses()
      }).subscribe({
        next: (responses) => {
          if (Array.isArray(responses.typeAnalyses)) {
            console.log('Types d\'analyses chargés avec succès:', responses.typeAnalyses);
            this.typeAnalyses = responses.typeAnalyses;  
          } else {
            console.error("La réponse des types d'analyses ne contient pas un tableau dans 'data'", responses.typeAnalyses);
          }
          if (Array.isArray(responses.clients.data)) {
            console.log('Clients chargés avec succès:', responses.clients.data);
            this.clients = responses.clients.data; 
          } else {
            console.error("La réponse des clients ne contient pas un tableau dans 'data'", responses.clients);
          }
          this.fetchDevisList();
        },
        error: (error) => {
          console.error('Erreur lors du chargement des clients et des types d\'analyses:', error);
        }
      });
    }

  onTypeAnalyseChange(): void {
    const selectedTypeAnalyseId = this.Form.get('typeAnalyseId')?.value;
    const selectedTypeAnalyse = this.typeAnalyses.find(
      (type) => type.id === selectedTypeAnalyseId
    );

    if (selectedTypeAnalyse) {
      this.prixUnitaire = selectedTypeAnalyse.prix; 
      this.Form.get('prixUnitaire')?.setValue(this.prixUnitaire);
    }
  }
    selectedTypeAnalyse: any = null;  
  
    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    initializePaginatorAndSort() {
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
        this.dataSource.filter = this.searchValue;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'desc';
    }
    initializeForm() {
        this.form = this.fb.group({
          //  numeroDevis: ['', Validators.required],
            clientId: ['', Validators.required],
            dateCreation: ['', Validators.required],
            clientReference:[''],
            dateExpiration: ['', Validators.required],
            dateLivraison: ['', Validators.required],
            delaiLivraison: ['', Validators.required],
            methodeExpedition: ['', Validators.required],
            conditionReglement: ['', Validators.required],
            validite: ['', Validators.required],
details: this.fb.array([]),
            status: ['', Validators.required],
        });
    }
    getClientNom(clientId: number): string {
        const client = this.clients.find(c => c.id === clientId);
        return client ? client.socialReason : 'Client non trouvé';
    }      
    getTypeAnalyseNom(typeAnalyseId: number): string {
        const typeAnalyse = this.typeAnalyses.find(t => t.id === typeAnalyseId);
        return typeAnalyse ? typeAnalyse.name : 'Type d\'analyse non trouvé';
      }
    
   fetchDevisList() {
        console.log('Chargement des devis...');       
        this.devisService.fetchAllDevis().subscribe({
          next: response => {
            console.log('Réponse reçue:', response);
            if (Array.isArray(response)) {
              this.dataSource.data = response.map(devis => {
                devis.details.forEach((detail: { typeAnalyseNom: string; typeAnalyseId: number }) => {
                  detail.typeAnalyseNom = this.getTypeAnalyseNom(detail.typeAnalyseId);
                });
                return {
                  ...devis,
                  clientNom: this.getClientNom(devis.clientId),
                  details: devis.details  
                };
              });
            } else if (response.status && Array.isArray(response.data)) {
              this.dataSource.data = response.data.map(devis => {
                devis.details.forEach((detail: { typeAnalyseNom: string; typeAnalyseId: number }) => {
                  detail.typeAnalyseNom = this.getTypeAnalyseNom(detail.typeAnalyseId);
                });  
                return {
                  ...devis,
                  clientNom: this.getClientNom(devis.clientId),
                  details: devis.details
                };
              });
            } else {
              console.error('Format de réponse inattendu:', response);
            }
      
            this.loadingTable = false;
          },
          error: err => {
            this.handleErrors.catchError(err);
            this.loadingTable = false;
          }
        });
      }
      
      openEditModal(element: DevisDTO, editModal: TemplateRef<DevisDTO>) {
        console.log('Edition du devis:', element);
        console.log('Valeur de TVA Applicable:', element.tvaApplicable);
        this.form.patchValue({
          id: element.id,
          numeroDevis: element.numeroDevis,
          clientId: element.clientId,
          dateCreation: element.dateCreation,
          clientReference:element.clientReference,
          dateExpiration: element.dateExpiration,
          dateLivraison: element.dateLivraison,
          delaiLivraison: element.delaiLivraison,
          methodeExpedition: element.methodeExpedition,
          conditionReglement: element.conditionReglement,
          validite: element.validite,
          status: element.status,  
          tvaApplicable: element.tvaApplicable,
        });
        this.devis = { ...element }; 
        console.log('Statut du devis:', this.devis.status);
      
        if (!element.status) {
          console.warn('⚠️ Aucun statut défini dans le devis.');
        }
  const detailsFormArray = this.form.get('details') as FormArray;
  detailsFormArray.clear();

  if (element.details && Array.isArray(element.details)) {
    element.details.forEach(detail => {
      detailsFormArray.push(this.fb.group({
        id:            [detail.id],
        typeAnalyseId: [detail.typeAnalyseId, Validators.required],
        qte:           [detail.qte,           Validators.required],
        prixUnitaire:  [detail.prixUnitaire,  Validators.required],
        total:         [detail.qte * detail.prixUnitaire]   // calcul ici
      }));
    });

    // 3) **Met à jour detailsList** pour l'affichage dans le tableau
    this.detailsList = element.details.map(d => ({
      ...d,
      total: d.qte * d.prixUnitaire
    }));
        } else {
          console.warn('⚠️ Aucun détail dans le devis.');
        }
      
        this.cdr.detectChanges();
        this.modalService.open(editModal, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
      }
      

    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
        }
    }

  confirmDelete(element: any) {
        this.dialogService.open(
            "Êtes-vous sûr de vouloir supprimer ce devis ?",
            environment.warning_message_type,
            'danger',
            environment.warning_icon,
            true
        ).then((result: any) => {
            if (result) {
                this.deleteDevis(element.id);
            }
        });
    }

    deleteDevis(id: number) {
      console.log("Suppression du devis avec l'id:", id);
      this.devisService.delete(id).pipe(
        tap((response: any) => {
          if (response.status) {
              this.removeTableRow(id);
              this.dialogService.openSuceessAlert('Parameter supprimé avec succès' );
          }
      }),
      finalize(() => {
          this.dataSource.paginator = this.paginator;
      })
  ).subscribe();
  }
  

    removeTableRow(id: number) {
      this.dataSource.data = this.dataSource.data.filter(sample => sample.id !== id);
      this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
  }
    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = this.searchValue;
    }

    handleSelection(rapport: DevisDTO) {
        if (this.selectedRapport.has(rapport)) {
            this.selectedRapport.delete(rapport);  
            console.log(`Rapport avec ID ${rapport.id} a été désélectionné`);
        } else {
            this.selectedRapport.add(rapport); 
            console.log(`Rapport avec ID ${rapport.id} a été sélectionné`);
        }
    
        console.log('Rapports sélectionnés:', Array.from(this.selectedRapport).map(item => item.id));
    }
    openModal(content: any) {
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'xl'}).result.then(
          () => {
              console.log('Modal fermé avec succès, réinitialisation du formulaire et des détails');
              this.Form.reset(); 
              this.detailForm.reset() 
              this.clearDetails(); 
          },
          () => {
              console.log('Modal fermé sans action, réinitialisation du formulaire et des détails');
              this.Form.reset(); 
              this.detailForm.reset() 
              this.clearDetails(); 
          }
      );
  }
  
  clearDetails(): void {
    const detailsArray = this.Form.get('details') as FormArray;
  
    // Supprimer tous les éléments du FormArray
    while (detailsArray.length) {
      detailsArray.removeAt(0);
    }
  
    // Réinitialiser detailsList
    this.detailsList = [];
  
    console.log('Tableau de détails réinitialisé');
  }

    saveDevis(): void {
      console.log('Formulaire valide:', this.Form.valid);  
      if (this.Form.valid) {
          console.log('Formulaire valide, préparation des données à soumettre');
         // const devis = this.Form.value;
          const devis = this.Form.getRawValue(); // ✅ pour inclure tous les champs même désactivés

          delete devis.status;
          console.log('Données du devis à envoyer:', devis);
  
          this.devisService.createDevis(devis).subscribe(
              (response) => {
                  console.log('Devis créé avec succès:', response);
                  this.Form.reset();
                  this.details.clear();
                  this.modalService.dismissAll(); 
                  this.fetchDevisList();
              },
              (error) => {
                console.error('Erreur lors de la création du devis:', error);
            
                const backendMessage = error?.error?.message;
                const message = backendMessage
                    ? backendMessage
                    : 'Une erreur est survenue lors de la création du devis.';
            
                this.dialogService.openDangerAlert(message); // ou utilisez un toast/snackbar si disponible
            }
          );
      } else {
          console.log('Formulaire invalide, vérifiez les champs');
          Object.keys(this.Form.controls).forEach((controlName) => {
              const control = this.Form.get(controlName);
              if (control && control.invalid) {
                  console.log(`Le champ ${controlName} est invalide. Erreurs:`, control.errors);
              }
          });
      }
  }
  
      
    handleSelectAll() {
        this.isAllRapportSelected = !this.isAllRapportSelected;
        this.selectedRapport = this.isAllRapportSelected
            ? new Set<DevisDTO>(this.dataSource.filteredData)
            : new Set<DevisDTO>();
    }

    handleIsAllColsSelected(event: MatCheckboxChange) {
        this.displayedColumns = event.checked ? [...this.columns] : [];
        this.setColsCookie();
    }

    getdisplayedCol = (): string[] => {
        return ['select', ...this.displayedColumns, 'action'];
    };

    onSelectionChange(column: string): void {
        this.displayedColumns = this.displayedColumns.includes(column)
            ? this.displayedColumns.filter(c => c !== column)
            : [...this.displayedColumns, column];
        this.setColsCookie();
    }

    user_name = sessionStorage.getItem('user_name');



    private setColsCookie() {
        this.cookieService.set(`devisCol_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }

    private getColsCookie() {
        const reportCols = this.cookieService.get(`devisCol_${this.user_name}`);
        if (reportCols) {
            this.displayedColumns = JSON.parse(reportCols);
            console.log('Colonnes récupérées:', reportCols);
        }
    }
    generateDevis(id: number) {
      this.loadingDevis = true;
      if (!id) {
          this.dialogService.openDangerDialog('Aucun devis sélectionné');
          this.loadingDevis = false;
          return;
      }
      console.log('ID du devis envoyé au backend:', id);
      this.devisService.downloadDevis([id]).subscribe(
          (response: Blob) => {
              console.log(`PDF reçu pour le devis avec ID: ${id}`);
  
              const blob = new Blob([response], { type: 'application/pdf' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `devis_${id}.pdf`; 
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
  
              console.log(`PDF pour le devis avec ID ${id} téléchargé avec succès.`);
          },
          (error) => {
              console.error(`Erreur lors du téléchargement du devis avec ID: ${id}`, error);
              this.dialogService.openDangerDialog('Erreur lors du téléchargement du devis');
          }
      );
  
      this.loadingDevis = false;
  }
  loadDevisForEdit(devis: any) {
    this.form.patchValue({
      id: devis.id,
      numeroDevis: devis.numeroDevis,
      dateCreation: devis.dateCreation,
      clientReference:devis.clientReference,
      dateExpiration: devis.dateExpiration,
      dateLivraison: devis.dateLivraison,
      tvaApplicable: devis.tvaApplicable,
      clientId: devis.clientId,
      status: devis.status,
      delaiLivraison: devis.delaiLivraison,
      methodeExpedition: devis.methodeExpedition,
      conditionReglement: devis.conditionReglement,
      validite: devis.validite
    });
  
    const detailsFormArray = this.form.get('details') as FormArray;
    detailsFormArray.clear(); 
  
    devis.details.forEach((d: any) => {
      detailsFormArray.push(this.fb.group({
        id: [d.id],
        typeAnalyseId: [d.typeAnalyseId, Validators.required],
        qte: [d.qte, Validators.required],
        prixUnitaire: [d.prixUnitaire, Validators.required],
        total : [d.qte * d.prixUnitaire]

      }));
    });
    
  }
  get detailsArray() {
    return (this.form.get('details') as FormArray);
  }
  
saveUpdatedDevis() {
  if (this.form.valid) {
    const formValue = this.form.value;

    const devis: DevisDTO = {
      ...formValue,
      updateDate: new Date().toISOString(),
      status: formValue.status as StatutsDevis,
      details: formValue.details ?? [],  // <-- Ajout ici pour forcer un tableau vide si null ou undefined

    };

    if (devis.id) {
      this.devisService.update(devis.id, devis).subscribe({
        next: (response) => {
          console.log('✅ Devis mis à jour avec succès:', response);
          this.modalService.dismissAll();
          this.fetchDevisList();
          this.router.navigate(['/propals']);
        },
        error: (error) => {
          console.error('❌ Erreur lors de la mise à jour du devis:', error);
        }
      });
    } else {
      console.error('❌ L\'ID du devis est manquant.');
    }
  } else {
    console.log('❌ Formulaire invalide, vérifiez les champs');
  }
}
modifierDevis(devisId: number, action: string) {
  const devisToSend = this.form.value;  // Formulaire avec les données du devis
  devisToSend.action = action;          // Ajouter l'action
  devisToSend.id = devisId;             // Ajouter l'ID

  console.log('Objet envoyé au backend :', devisToSend); // ✅ Ajout ici

  this.devisService.updateDevisStatus(devisId, devisToSend).subscribe(
    (response) => {
      console.log('Devis mis à jour avec succès', response);
      this.modalService.dismissAll();
      this.fetchDevisList();
    },
    (error) => {
      console.error('Erreur lors de la mise à jour du devis', error);
    }
  );
}


envoyerDevis(id: number) {
  this.devisService.envoyerDevis(id).subscribe({
    next: updatedDevis => {
      this.devis = updatedDevis;
      this.dialogService.openSuccessDialog('Devis envoyé au client');
      this.fetchDevisList();
    },
    error: error => {
      console.error('❌ Erreur lors de l’envoi du devis:', error);

      let backendMessage = error?.error?.message;

      // 🧠 Si le message est du JSON stringifié, on le parse
      if (typeof backendMessage === 'string') {
        try {
          const parsed = JSON.parse(backendMessage);
          backendMessage = parsed?.message || backendMessage;
        } catch (e) {
          // ce n’est pas du JSON valide, on garde tel quel
        }
      }

      const message = backendMessage
        ? backendMessage
        : 'Une erreur est survenue lors de l’envoi du devis.';

      this.dialogService.openDangerAlert(message);
    }
  });
}


validerDevis(id: number) {
  this.devisService.validerDevis(id).subscribe({
    next: updatedDevis => {
      this.devis = updatedDevis;
      this.dialogService.openSuccessDialog('Devis validé avec succès');
      this.fetchDevisList();
    },
    error: error => {
      console.error('Erreur lors de la validation du devis:', error);

      let backendMessage = error?.error?.message;

      // 🧠 Si le message est du JSON stringifié, on le parse
      if (typeof backendMessage === 'string') {
        try {
          const parsed = JSON.parse(backendMessage);
          backendMessage = parsed?.message || backendMessage;
        } catch (e) {
          // ce n’est pas du JSON valide, on garde tel quel
        }
      }

      const message = backendMessage
        ? backendMessage
        : 'Une erreur est survenue lors de l’envoi du devis.';

      this.dialogService.openDangerAlert(message);
    }
  });
}

  EnCoursDevis(id: number) {
    this.devisService.EnCoursDevis(id).subscribe({
      next: updatedDevis => {
        this.devis = updatedDevis;
        this.dialogService.openSuccessDialog('Devis en cours avec succès');
        this.fetchDevisList(); 
      },
      error: err => {
        this.dialogService.openDangerAlert('Erreur lors de la validation du devis');
      }
    });
  }

  accepterDevis(id: number, clientReference: string) {
    console.log('📩 Appel de accepterDevis avec :');
    console.log('🆔 ID =', id);
    console.log('📌 Référence client =', clientReference);
  
    if (!clientReference) {
      console.warn("⚠️ La référence client est vide !");
      this.dialogService.openDangerAlert("La référence client est obligatoire pour accepter le devis.");
      return;
    }
  
    this.devisService.accepterDevis(id, clientReference).subscribe({
      next: updatedDevis => {
        console.log('✅ Réponse reçue du backend après acceptation :', updatedDevis);
        this.dialogService.openSuccessDialog('Devis accepté avec succès');
        this.fetchDevisList();
      },
      error: error => {
        console.error('❌ Erreur lors de l’envoi du devis:', error);
        const backendMessage = error?.error?.message;
        const message = backendMessage
          ? `Erreur lors de l’envoi du devis: ${backendMessage}`
          : 'Une erreur est survenue lors de l’envoi du devis.';
        this.dialogService.openDangerAlert(message);
      }
    });
  }
  
  
  closePdfPreview() {
    this.pdfPreviewUrl = null;
  }
  devisPreviewId: number | null = null;

  generateDevisPreview(devisIds: number[]) {
    console.log("Demande de prévisualisation pour les devis avec les IDs:", devisIds);
  
    if (devisIds.length === 1) {
      this.devisPreviewId = devisIds[0]; // <-- On garde l'ID pour transformer en bon de commande
    }
  
    this.devisService.previewDevisPdf(devisIds).subscribe({
      next: (response: Blob) => {
        if (response instanceof Blob) {
          const fileURL = URL.createObjectURL(response);
          this.pdfPreviewUrl = fileURL;
        } else {
          console.error("La réponse n'est pas un Blob valide", response);
        }
      },
      error: (err) => {
        console.error("Erreur lors du preview PDF:", err);
      }
    });
  }
  
  
  creerBonCommandeDepuisDevis(id: number) {
    console.log('Tentative de création de bon de commande pour le devis ID:', id);
    
    this.devisService.creerBonCommandeDepuisDevis(id).subscribe({
      next: (response: any) => {
        console.log('Réponse du serveur:', response);
        this.dialogService.openSuccessDialog('Bon de commande créé avec succès');
        this.fetchDevisList();
      },
      error: (err) => {
        console.error('Erreur lors de la création du bon de commande:', err);
        if (err.error) {
          console.error('Détails de l\'erreur:', err.error);
          this.dialogService.openDangerAlert(`Erreur: ${err.error.message || err.statusText}`);
        } else {
          this.dialogService.openDangerAlert('Erreur inconnue lors de la création du bon de commande');
        }
      }
    });
  }
  
  rejeterDevis(id: number) {
    this.devisService.rejeterDevis(id).subscribe({
      next: updatedDevis => {
        this.devis = updatedDevis;
        this.dialogService.openSuccessDialog('Devis rejeté');
        this.fetchDevisList();  
      },
      error: err => {
        this.dialogService.openDangerAlert('Erreur lors du rejet du devis');
      }
    });
  }
}
  